// categoryData.js (or place above the FilterPopup component)
export const categoryData = {
  "Act": {
    "Authority": ["Other", "Municipal"],
    "General Admin": ["Governance", "Employee service", "Other"],
    "Land": ["Development", "Acquisition", "Title"],
    "Miscellaneous": ["Offences", "Environment", "Other", "Valuation"],
    "Town Planning": ["MRTP", "Buildings", "Development Control", "Other"]
  },

  "Rule": {
    "Civil Services": [
      "Service",
      "Recruitment",
      "Pay Rule",
      "Retirement and Pension"
    ],
    "Miscellaneous": ["Other"],
    "Other DCR": ["Clarification"],
    "UDCPR": ["Clarification", "Modification"]
  },

  "Directive": {
    "Plans": ["DP", "Other"],
    "Development Permission": [
      "Unauthorised Constructions",
      "Land Development",
      "Building Development",
      "Development Charges"
    ],
    "Reservation Lands": ["TDR / AR", "DP Reservation"],
    "Other": ["DCR", "Power Delegation", "Other"]
  },

  "GR": {
    "Urban Land Ceiling (ULC)": [
      "Administration",
      "7/12 Entries",
      "New Premium policy",
      "Housing Scheme",
      "Flat Allocation/ Transfer",
      "Land Allocation/ Transfer",
      "Talegaon Dabhade Scheme",
      "Extension ( Mudatwadh)",
      "Other"
    ]
  },

  "Circular": {
    "Town Planning": ["DP"],
    "General Administration": ["Establishment (Akrutibandh)"],
    "Urban Land Ceiling (ULC)": [
      "New Premium policy",
      "Housing Scheme",
      "Land Allocation/ Transfer",
      "Flat Allocation/ Transfer",
      "Administration",
      "Extension ( Mudatwadh)",
      "Other"
    ]
  },

  "Court Judgment": {
    "Land Acquisition": ["Other", "ULC", "Public Purpose"],
    "Land acquisition MRTP": [
      "Section 127",
      "Section 49",
      "Compensation / TDR",
      "Other"
    ],
    "Development Permission": [
      "Other",
      "Unauthorised Constructions",
      "Reservation Restriction",
      "Appeal Section 47"
    ],
    "Other": ["Administration", "Governance", "Other"]
  },

  "Articles": {
    "Town Planning": [
      "Other",
      "Transportation",
      "Urban & Regional Planning",
      "Environment"
    ],
    "Valuation": [
      "Rate Fixation",
      "Valuation Methods",
      "Valuation Guidelines"
    ],
    "Other": ["Administration", "E-Governance", "Other"]
  }
};
